import {
  SET_BANK_UPLOADING,
  SET_STATUS_LOADER,
  SET_BANK_UPLOADING_ID,
} from "./actionType";

const INIT_STATE = {
  data: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    title: "",
    results: [],
  },
  payment: {},
  isError: false,
  loading: false,
  error: null,
};

const BankUploading = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_BANK_UPLOADING: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case SET_BANK_UPLOADING_ID: {
      return {
        ...state,
        payment: action.payload,
      };
    }
    case SET_STATUS_LOADER: {
      return {
        ...state,
        loading: !state.loading,
      };
    }
    default:
      return state;
  }
};

export default BankUploading;
